if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
        this.nav = null;
        this.navItems = null;
        this.headings = null;
        this.observer = null;
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;
        this.hasNavigation = this.dataset.navigation === 'true';

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });

        if (this.hasNavigation) {
          this.initNavigation();
        }
      }

      initNavigation() {
        this.nav = this.closest('.section').querySelector('.collapsible-tabs-nav');
        this.navItems = this.nav?.querySelectorAll('.collapsible-tabs-nav__item');
        this.headings = this.querySelectorAll('.block-heading[id]');

        if (this.nav && this.navItems) {
          this.setupNavigation();
          this.setupStickyNav();
          this.handleInitialHash();
        }
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }

      setupNavigation() {
        if (!this.navItems) return;

        this.navItems.forEach(item => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = item.getAttribute('href').substring(1);
            const targetHeading = document.getElementById(targetId);
            
            if (targetHeading) {
              this.scrollToHeading(targetHeading);

            }
          });
        });
      }

      setupStickyNav() {
        if (!this.nav) return;

        const section = this.closest('.section');
        const sectionTop = section.offsetTop;
        
        const checkSticky = () => {
          const scrollTop = window.pageYOffset;
          const shouldStick = scrollTop > sectionTop;
          
          this.nav.classList.toggle('is-sticky', shouldStick);
        };

        window.addEventListener('scroll', checkSticky);
        window.addEventListener('resize', checkSticky);
        checkSticky();
      }

      handleInitialHash() {
        if (window.location.hash) {
          const targetHeading = document.querySelector(window.location.hash);
          if (targetHeading && this.contains(targetHeading)) {
            setTimeout(() => {
              this.scrollToHeading(targetHeading);
            }, 100);
          }
        }
      }

      scrollToHeading(targetHeading) {
        const headerHeight = document.querySelector('.site-header')?.offsetHeight || 0;
        const navHeight = this.nav?.offsetHeight || 0;
        const offset = headerHeight + navHeight + 20;

        const targetPosition = targetHeading.offsetTop - offset;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }
  );
}
